"use client";

import { cn } from "@/lib/tailwind";
import React, { ReactNode, useState } from "react";

export interface IProp {
  options: Array<{
    title: string | null;
    content: ReactNode;
  } | null>;
  containerClass?: string;
  tabsContainerClass?: string;
  contentContainerClass?: string;
  handleTabChange: (idx: number) => void;
  index: number;
}

const TabsV2 = ({
  options,
  containerClass,
  tabsContainerClass,
  contentContainerClass,
  handleTabChange,
  index,
}: IProp) => {

  return (
    <div>
      <div className={cn("w-full", containerClass)}>
        {
          <div className={cn("no-scrollbar w-full overflow-x-scroll", tabsContainerClass)}>
            {options.map((item, idx) =>
              item && item?.title ? (
                <div
                  key={idx}
                  role="button"
                  className={cn(
                    "flex items-center justify-center px-3 py-2.5 text-sm",
                    idx === index
                      ? "border-b-[3px] border-secondary-1 font-semibold"
                      : "bg-[#EEEEEE]",
                  )}
                  onClick={() => handleTabChange(idx)}
                >
                  {item.title}
                </div>
              ) : (
                <></>
              ),
            )}
          </div>
        }
        <div className={cn(contentContainerClass)}>{options[index]?.content}</div>
      </div>
    </div>
  );
};

export default TabsV2;
